export default __webpack_public_path__ + "static/media/linkedInLogo.cf153672.svg";